<div class="filter-more-item" *ngIf="mobile">
  <label class="upper-label" for="minPrice">Price range</label>
  <ng-container *ngTemplateOutlet="priceRange"></ng-container>
</div>

<ng-container *ngIf="!mobile">
  <div
    class="filter-item"
    [matMenuTriggerFor]="priceFilter"
    #trigger="matMenuTrigger"
    [ngClass]="{ active: label !== 'Any price' || isOpen, mobile: mobile }"
    (menuOpened)="isOpen = true"
    (menuClosed)="isOpen = false"
  >
    <span>{{ label }}</span>
    <app-shared-icon name="chevron-down-2"></app-shared-icon>
  </div>

  <mat-menu #priceFilter="matMenu" xPosition="after" class="filters-mat-menu">
    <div
      class="filter-dropdown lg with-padding"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <h4>Price range</h4>
      <ng-container *ngTemplateOutlet="priceRange"></ng-container>
    </div>
  </mat-menu>
</ng-container>

<ng-template #priceRange>
  <div class="inputs grid grid-cols-2 gap-x-4">
    <app-shared-input
      label="Min"
      prefix="$"
      [for]="'minPrice'"
      [value]="minValue || 'Any'"
    >
      <input
        placeholder="No min"
        name="minPrice"
        id="minPrice"
        type="text"
        mask="separator.0"
        thousandSeparator=","
        [(ngModel)]="minValue"
        (blur)="onInputChange()"
        (keyup.enter)="onInputChange()"
        inputmode="numeric"
        (focus)="selectAll($event)"
      />
    </app-shared-input>
    <app-shared-input
      label="Max"
      prefix="$"
      [for]="'maxPrice'"
      [value]="maxValue || 'Any'"
    >
      <input
        placeholder="No max"
        name="maxPrice"
        id="maxPrice"
        type="text"
        mask="separator.0"
        thousandSeparator=","
        [(ngModel)]="maxValue"
        (blur)="onInputChange()"
        (keyup.enter)="onInputChange()"
        inputmode="numeric"
        (focus)="selectAll($event)"
      />
    </app-shared-input>
  </div>

  <div class="-mt-2" *ngIf="!mobile">
    <app-filter-v2-buttons
      (resetAction)="resetPrice()"
      (applyAction)="closeMenu()"
      position="right"
    ></app-filter-v2-buttons>
  </div>
</ng-template>
